/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
 import 'what-input'
 import jQuery from 'jquery';
 import Foundation from 'foundation-sites'
 import intlTelInput from 'intl-tel-input'
 import Swiper, { Navigation, Pagination, Thumbs, Autoplay, EffectFlip, EffectCube, EffectFade, EffectCoverflow } from 'swiper'
//  import 'owl.carousel'
 import { setHrefs } from './functions/data-hrefs'
 import { initEqualizeContent } from './functions/equalizer'
 import { initTelephoneInput } from './functions/intl-tel-input'
 import { initDatepickerInput } from './functions/datepicker'
 import { enableNegativeMargins } from './functions/negative-margins'
 import { mapStyles } from './functions/map-styles'
 import 'foundation-datepicker'
import { formatDate } from './functions/format-date'

// import { enableCallrailTracking } from './functions/callrail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */


 
/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/rgv_tours_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"
const OWL_CAROUSEL = "node_modules/owl.carousel"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Thumbs, Autoplay, EffectFlip, EffectCube, EffectFade, EffectCoverflow])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();

	// TESTIMONIALS
	var testimonialSwiper = new Swiper('#testimonials .swiper-container',{
		direction: 'horizontal',
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: '#testimonials .swiper-navigation .swiper-button-next',
			prevEl: '#testimonials .swiper-navigation .swiper-button-prev',
		},
		pagination: {
			el: '#testimonials .swiper-pagination',
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 1,
		}
	});

	// SINGLE PROPERTY GALLERY
	// reference for main items
	// var singlePropertyCarousel = jQuery('#single-property-carousel');
	// console.log('FFFFFFF', singlePropertyCarousel);

	//transition time in ms
	// var duration = 300;

	// singlePropertyCarousel.owlCarousel({
	// 	items: 1,
	// 	loop:false,
	// 	margin:0,
	// 	nav:false,
	// 	dots:false,
	// 	autoplay:true,
	// 	autoplayTimeout:15000,
	// })

	var singlePropertyThumbnailCarousel = new Swiper("#single-property-carousel-thumbs", {
		loop: false,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
		
	});

	var singlePropertyCarousel = new Swiper("#single-property-carousel", {
		loop: false,
        spaceBetween: 10,
		slidesPerView: 1,
		autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
		thumbs: {
			swiper: singlePropertyThumbnailCarousel,
		  },
        
	});

	

});

	

/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */